import React, { useState, useEffect } from "react";

const AnnouncementBar = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Blinks on and off in fractions of a second (every 400ms)
    const interval = setInterval(() => {
      setIsVisible((prev) => !prev);
    }, 400);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-green-600 text-white py-2.5 px-4 w-full flex items-center justify-center text-center overflow-hidden shadow-sm">
      <div
        className={`transition-opacity duration-150 ease-in-out whitespace-normal md:whitespace-nowrap ${
          isVisible ? "opacity-100" : "opacity-0"
        }`}
      >
        <span className="text-white text-base md:text-lg font-medium">
          <span className="font-bold">Announcement</span> : Nohmi Bosai India has entered into a strategic partnership with Universal Sompo General Insurance.
        </span>
      </div>
    </div>
  );
};

export default AnnouncementBar;
